import routes from './routes';
import { SetRoutes } from 'components';

const WaitingListsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default WaitingListsPages;
